import { I18n } from "@assets/strings";
import React, { useMemo } from "react";
import styled from "styled-components";
import { SubtitleSection } from "@domain/lms/course/courseSection";
import { MaterialTextInput } from "@ui/components/inputs/materialTextInput";
import { useChapterController } from "@ui/pages/lms/courseEditorPage/courseEditorController/editorControllerContext";

interface SubtitleSectionEditorProps extends React.HTMLAttributes<HTMLDivElement> {
	section: SubtitleSection;
}

export const SubtitleSectionEditor: React.FC<SubtitleSectionEditorProps> = ({ section, ...htmlProps }) => {
	const chapterController = useChapterController();
	const subtitleController = useMemo(() => chapterController.subtitleSectionController(section), [section]);

	return (
		<StyledInput
			{...htmlProps}
			placeholder={I18n.t("course.editor.section.subtitle.placeholder")}
			value={section.title}
			onChange={(v) => subtitleController.setTitle(v)}
		/>
	);
};

const StyledInput = styled(MaterialTextInput)`
	input,
	input::placeholder {
		font-size: 1.25rem;
	}
`;
